import{m as r}from"./chunk-HBP5N4FR.js";r();var e=t=>t?t.lastIndexOf(".elrond")>0?t.substring(0,t.lastIndexOf(".")):t:void 0;export{e as a};
//# sourceMappingURL=chunk-CTRUFMPD.js.map
